import { initSplideCarousel } from '@/splide-carousel';
import { revealOnScroll, motionTokens } from '@/motion-primitives';

/** Tailwind breakpoints (max-width, for Splide's default `mediaQuery: 'max'`). */
const LG_MAX = 1023;
const MD_MAX = 767;

/** Splide easing aligned with the project's "warm" curve (ease-out-quart). */
const RMH_SPLIDE_EASING = `cubic-bezier(${motionTokens.easeOut.join(',')})`;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-story-carousel').forEach((block) => {
		initSplideCarousel(block, {
			perMove: 1,
			gap: '2rem',
			trimSpace: 'move',
			fixedWidth: '843px',
			speed: 600,
			easing: RMH_SPLIDE_EASING,
			breakpoints: {
				[LG_MAX]: {
					fixedWidth: '540px',
					gap: '1.25rem',
				},
				[MD_MAX]: {
					fixedWidth: '258px',
				},
			},
		});

		revealOnScroll(block, { duration: motionTokens.durLg });
	});
});
